import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedResidenceStudyCriteriaApiService } from './residence-study-criteria-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ResidenceStudyCriteriaApiService extends GeneratedResidenceStudyCriteriaApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
